import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from '../../core/core.module';
import { MainModule } from '../../main/main.module';
import { ReactComponentsModule } from '../../react-components/react-components.module';
import { SharedModule } from '../../shared/shared.module';
import { AttendanceModule } from '../attendance/attendance.module';
import { CreateFlexPeriodComponent } from './create-flex-period/create-flex-period.component';
import { FlexPeriodRoutingModule } from './flex-period-routing.module';
import { FlexPeriodComponent } from './flex-period.component';

@NgModule({
	declarations: [CreateFlexPeriodComponent, FlexPeriodComponent],
	imports: [
		CommonModule,
		FlexPeriodRoutingModule,
		MainModule,
		CoreModule,
		ReactiveFormsModule,
		SharedModule,
		ReactComponentsModule,
		AttendanceModule,
	],
	exports: [FlexPeriodComponent],
})
export class FlexPeriodModule {}
